// Lib
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(5),
    marginBottom: theme.spacing(2.5),
    marginTop: theme.spacing(3.5),
    '& > h3': {
      flexBasis: 'calc(50% - 20px)',
    },
  },
  emptyImport: {
    fontSize: 18,
    color: theme.palette.darkGrey,
    marginTop: theme.spacing(3.75),
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 16,
      }),
    },
  },
}));
